import type { FC } from 'react';
import React from 'react';
import { AnalyticsEventSender } from '@alfa-bank/site-analytics-event-sender/analytics-event-sender';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { Link } from '@alfa-bank/site-link';

import { defaultAnchorLink, primaryButtonText } from '../../../configs';
import type { TOpenAccountButton } from '../models';

export const OpenAccountButton: FC<TOpenAccountButton> = ({
    analytics,
    anchorLink = defaultAnchorLink,
    buttonText = primaryButtonText,
    styler,
}) => {
    return (
        <AnalyticsEventSender
            $events={{
                onClick: {
                    data: analytics?.headerPrimaryButtonClick,
                },
            }}
        >
            <Link href={anchorLink} noUnderline>
                <Button block size="m" styler={styler} view="primary">
                    {buttonText}
                </Button>
            </Link>
        </AnalyticsEventSender>
    );
};
